import { SET_SEARCH_TRANSACTION } from '../constants';

export interface SetSearchTransactionAction {
  type: typeof SET_SEARCH_TRANSACTION;
  payload: string;
}

export type SearchTransactionActions = SetSearchTransactionAction;

export const setSearchTransaction = (
  transaction: string,
): SetSearchTransactionAction => ({
  type: SET_SEARCH_TRANSACTION,
  payload: transaction,
});
